import "./assets/main.css";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import store from "./store";
import setupInterceptors from "./services/setupInterceptors";

import * as Sentry from "@sentry/vue";

Vue.config.productionTip = false;

setupInterceptors(store);

// Handle CSS/JS chunk load failures after a deploy (stale cache issue).
// Re-loading the page fetches the new bundle and resolves the error.
window.addEventListener('error', (event) => {
  if (
    event.message &&
    (event.message.includes('Loading chunk') || event.message.includes('Loading CSS chunk'))
  ) {
    event.preventDefault();
    window.location.reload();
  }
});

// Catch any 401 unhandled promise rejections that slip past the axios interceptor
// (e.g. from third-party calls or interceptor misconfiguration).
window.addEventListener('unhandledrejection', function(event) {
  if (event.reason && event.reason.response && event.reason.response.status === 401) {
    store.dispatch('auth/logout');
    router.push('/home').catch(() => {});
  }
});

Sentry.init({
  Vue,
  dsn: "https://473a9cb226ff789978861dfc109df0e3@o4508794503692288.ingest.de.sentry.io/4508794505986128",
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0,
  // Only propagate traces to our actual API servers
  tracePropagationTargets: [
    /^https:\/\/api\.ukpl\.co\.uk/,
    /^https:\/\/adminecpl\.ukpl\.co\.uk/,
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  // Suppress known third-party noise
  ignoreErrors: [
    "Can not send postrobot_method. Target window is closed",
    "Error invoking postMessage: Java object is gone",
    /Loading (CSS )?chunk .+ failed/,
  ],
  beforeSend(event, hint) {
    const error = hint.originalException;

    // Don't report 401s — these are handled by the interceptor
    if (error && error.isAxiosError && error.response && error.response.status === 401) {
      return null;
    }

    // Suppress localhost events leaking into production Sentry
    if (event.request && event.request.url && event.request.url.startsWith('http://localhost')) {
      return null;
    }

    return event;
  },
});

new Vue({
  router,
  vuetify,
  store,
  render: (h) => h(App),
}).$mount("#app");
